import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _excluded = ["className", "children", "title", "extra", "codeProps"];
var _templateObject, _templateObject2;
import React from 'react';
import styled from 'styled-components';
import { GlobalStyle } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Code = styled.pre(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  border-color: var(--color-border-result-code);\n  border-width: 1px;\n  border-style: solid;\n  padding: 10px 15px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;\n  word-break: break-all;\n  white-space: pre-wrap;\n"])));
var Title = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
export var ResultCode = _ref => {
  var {
      className,
      children,
      title,
      extra,
      codeProps
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", _extends({
    className: className
  }, other, {
    children: [/*#__PURE__*/_jsx(GlobalStyle, {}), /*#__PURE__*/_jsxs(Title, {
      children: [/*#__PURE__*/_jsx("span", {
        children: title
      }), extra]
    }), /*#__PURE__*/_jsx(Code, _extends({}, codeProps, {
      children: children
    }))]
  }));
};